var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon--download icon",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.795 8.545V.864c0-.364-.205-.569-.569-.569h-.795c-.364 0-.568.205-.568.569v7.704c0 .114-.091.16-.16.068l-2.772-2.84c-.25-.273-.546-.273-.796-.023l-.545.522c-.273.273-.25.546.023.819l3.954 3.75c.205.204.432.409.682.59.227.182.41.25.568.25.16 0 .341-.068.568-.25a5.79 5.79 0 0 0 .682-.59l3.955-3.75c.273-.273.273-.546 0-.819l-.546-.5c-.272-.25-.545-.25-.795.023L7.954 8.614c-.069.09-.16.045-.16-.069Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16h14v2H0v-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/Download-Icon.96e8a9c38750d72cfbc0b41140ccdefd.svg";
export { ForwardRef as ReactComponent };